/**
 * Hardcoded Jurnal Templates — kode akun diresolusi ke ID saat dipilih.
 * Setiap line berisi {code, side ('debit'|'credit'), memo}.
 * Total dihitung dari input user (satu nominal → di-apply ke semua baris).
 */
export const JURNAL_TEMPLATES = [
  {
    id: 'sewa',
    name: 'Sewa Toko / Ruko',
    description: 'Pembayaran sewa bulanan',
    lines: [
      { code: '6-3000', side: 'debit',  memo: 'Beban Sewa' },
      { code: '1-1000', side: 'credit', memo: 'Kas' },
    ],
  },
  {
    id: 'listrik',
    name: 'Listrik / Air / Internet',
    description: 'Pembayaran tagihan utilitas',
    lines: [
      { code: '6-4000', side: 'debit',  memo: 'Beban Utilitas' },
      { code: '1-1000', side: 'credit', memo: 'Kas' },
    ],
  },
  {
    id: 'setoran_bank',
    name: 'Setoran Kas ke Bank',
    description: 'Setor tunai dari kas ke rekening bank',
    lines: [
      { code: '1-1100', side: 'debit',  memo: 'Bank' },
      { code: '1-1000', side: 'credit', memo: 'Kas' },
    ],
  },
  {
    id: 'tarik_bank',
    name: 'Tarik Tunai dari Bank',
    description: 'Ambil tunai dari rekening bank ke kas',
    lines: [
      { code: '1-1000', side: 'debit',  memo: 'Kas' },
      { code: '1-1100', side: 'credit', memo: 'Bank' },
    ],
  },
  {
    id: 'beli_persediaan_tunai',
    name: 'Beli Persediaan (Tunai)',
    description: 'Pembelian barang dagang tunai',
    lines: [
      { code: '1-1400', side: 'debit',  memo: 'Persediaan Barang' },
      { code: '1-1000', side: 'credit', memo: 'Kas' },
    ],
  },
  {
    id: 'terima_uang_muka',
    name: 'Terima Uang Muka Pelanggan',
    description: 'DP dari pelanggan',
    lines: [
      { code: '1-1000', side: 'debit',  memo: 'Kas' },
      { code: '2-2000', side: 'credit', memo: 'Uang Muka Pelanggan' },
    ],
  },
];
